<template lang="pug">
.booking-details.bg-grey
  QuickActions(@peformIntegrationActionRedirect="peformIntegrationActionRedirect")
  .content
    .internal-nav
      .links
        router-link(:to="{name: 'BookingView'}" data-test-id="booking-tab-link") Booking
        router-link(:to="{name: 'BookingCustomer'}" data-test-id="customer-tab-link") Customer
        router-link(:to="{name: 'BookingVisitors'}" data-test-id="visitors-tab-link") Visitors
        router-link(:to="{name: 'BookingNotes'}" data-test-id="notes-tab-link") Notes
        router-link(:to="{name: 'BookingPayments'}" data-test-id="payments-tab-link") Payments
        router-link(:to="{name: 'BookingMail'}" data-test-id="mail-tab-link") Mail
      .buttons.mr-S
        BriqViewAuditTrail(v-if="showAuditTrail" objectType="Booking" :objectKey="bookingKey")
        // todo use link buttons
        BriqButton(v-if="businessAllowsEditSchedule" @click="editSchedule" :disabled="disableEditBooking" data-test-id="edit-schedule-button") Edit schedule
        BriqButton(v-if="businessAllowsEditBooking" @click="editBooking" :disabled="disableEditBooking" data-test-id="edit-booking-button") Edit booking
    transition(name="fade" mode="out-in")
      router-view(v-if="bookingDetails")
      .error(v-else-if="fetchError")
        h1 {{ errorMessage }}
      Spinner(v-else)
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Spinner from '@v/components/Spinner.vue'
import QuickActions from './QuickActions.vue'
import BusinessFeature from '@v/models/BusinessFeatureEnum.js'
import Permission from '@v/models/UserPermissionEnum.js'

export default {
  name: 'BookingDetails',
  components: { QuickActions, Spinner },
  computed: {
    ...mapState('bookingDetails', ['fetchError', 'bookingDetails']),
    ...mapGetters('bookingDetails', ['wasFetchedOk', 'isPending', 'bookingKey']),
    ...mapGetters('briqState', [
      'userCanViewAuditTrail',
      'businessUnitHasFeature',
      'userHasPermission',
    ]),
    disableEditBooking() {
      return this.pending || !this.userHasPermission(Permission.API_Admin_Booking_Product_Create)
    },
    showAuditTrail() {
      return this.wasFetchedOk && this.userCanViewAuditTrail
    },
    businessAllowsEditSchedule() {
      return this.businessUnitHasFeature(BusinessFeature.BookingEditSchedule)
    },
    businessAllowsEditBooking() {
      return this.businessUnitHasFeature(BusinessFeature.BookingEdit)
    },
    errorMessage() {
      switch (this.fetchError.parsedError?.status) {
        case 500:
          return 'Internal server error'
        case 404:
          return '404: Booking not found'
        case 403:
          return '403: No permission'
        default:
          return 'Something went wrong...'
      }
    },
  },
  methods: {
    editSchedule() {
      this.$setLocationPath(`planboard?booking=${this.bookingKey}&edit=1`)
    },
    editBooking() {
      this.$setLocationPath(`bookings/${this.bookingKey}/edit`)
    },
    async peformIntegrationActionRedirect(payload) {
      const success = await this.$store.dispatch(
        'bookingDetails/peformIntegrationActionRedirect',
        payload,
      )
    },
  },
}
</script>

<style scoped lang="stylus">
.booking-details
  display flex
  width 100%
  min-height 100vh

.content
  width 100%
  min-height 100vh

.internal-nav
  background white
  display flex
  justify-content space-between
  align-items center
  border-bottom solid 1px #ececec

  .links
    display flex
    padding-left 28px

    a
      padding 27px 18px
      font-size 16px
      color #2c333a
      transition color 0.15s ease

      &:hover
        color #009bff

      &.router-link-exact-active
        font-weight bold

.error
  text-align center
  margin-top 64px

@media print
  .internal-nav
    display none
  .view-booking
    display block !important
</style>
